<template>
  <v-footer
    app
    clipped-left
    dark
    fixed
    padless
  >
    <v-row
      class="align-center"
      dense
    >
      <v-col
        :style="`min-width: ${$vuetify.breakpoint.xsOnly ? 68 : 75}px;`"
        class="shrink"
      >
        <v-fade-transition>
          <v-btn
            min-width="55"
            plain
            x-small
            @click="showVersion = !showVersion"
          >
            <span
              v-show="showVersion"
              class="caption grey--text"
            >v{{ $dataStore.App.Version }}</span>
          </v-btn>
        </v-fade-transition>
      </v-col>

      <v-col>
        <div
          :style="$vuetify.breakpoint.xsOnly ? 'font-size: 11px' : 'font-size: 12px'"
          class="pa-1 text-center"
        >
          {{ new Date().getFullYear() }} &copy;
          <span class="pl-1">{{ $t('Common.App.Title') }}</span>
        </div>
      </v-col>

      <v-col class="text-right shrink">
        <v-btn
          v-if="$route.meta && $route.meta.layout && $route.meta.layout.toLowerCase() !== 'login'"
          class="mr-1"
          depressed
          fab
          x-small
          @click="toggleThemeDark"
        >
          <v-icon>mdi mdi-invert-colors</v-icon>
        </v-btn>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>

export default {
  name      : 'AppFooter',
  components: {},
  directives: {},
  mixins    : [],
  props     : {},
  data () {
    return {
      showVersion: false
    }
  },
  computed: {},
  watch   : {},
  beforeCreate () {},
  created () {
    this.$vuetify.theme.dark = this.$localStorage.get('dark', this.$vuetify.theme.dark)
  },
  beforeMount () {},
  mounted () {},
  beforeUpdate () {},
  updated () {},
  beforeDestroy () {},
  destroyed () {},
  methods: {
    toggleThemeDark () {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark
      this.$localStorage.set('dark', this.$vuetify.theme.dark)
    }
  }
}
</script>

<style scoped>

</style>
